namespace $.$$ {

	export class $shm_hitalama_profile_page extends $.$shm_hitalama_profile_page {

		profile() {
			return this.$.$shm_hitalama_profile.current()
		}

		avatar_uri() {
			return this.$.$shm_hitalama_profile.avatar_uri( this.profile()?.Avatar()?.remote() )
		}

		avatar_delete_visible() {
			return this.profile()?.Avatar()?.remote() ? [ this.Avatar_delete() ] : []
		}

		@ $mol_action
		avatar_files( next?: readonly File[] ) {
			if( next === undefined ) return []
			const source = next[ 0 ]
			if( !source ) return []
			if( !source.type.startsWith( 'image/' ) ) {
				this.message( 'Выберите изображение' )
				return []
			}

			const avatar = this.$.$giper_baza_glob
				.land_grab( [[ null, this.$.$giper_baza_rank_read ]] )
				.Data( this.$.$shm_hitalama_file )
			avatar.write( source )
			this.profile()?.Avatar( null )?.remote( avatar )
			this.$.$shm_hitalama_profile.user_name_publish()
			this.message( this.message_saved() )
			return []
		}

		@ $mol_action
		avatar_delete( next?: Event ) {
			if( next === undefined ) return null
			this.profile()?.Avatar( null )?.remote( null )
			this.$.$shm_hitalama_profile.user_name_publish()
			this.message( this.message_saved() )
			return next
		}

		profile_key() {
			const profile = this.profile()
			if( !profile ) return null

			const profile_link = profile.link().toString()
			const profile_login = profile.Login()?.val()
			if( profile_login ) {
				const linked = this.profiles().key( profile_login )?.remote()
				if( linked?.link().toString() === profile_link ) return profile_login
			}

			for( const key of this.profiles().keys() ) {
				if( this.profiles().key( key )?.remote()?.link().toString() === profile_link ) return String( key )
			}

			return null
		}

		@ $mol_mem
		login( next?: string ): string {
			this.message( '' )
			if( next !== undefined ) return next
			return this.profile()?.Login()?.val() ?? ''
		}

		@ $mol_mem
		secret_key() {
			const auth = this.$.$giper_baza_auth.current()
			return auth.toString() + auth.toStringPrivate()
		}

		@ $mol_mem
		client_id() {
			return this.$.$giper_baza_auth.current().pass().lord().str
		}

		@ $mol_mem
		message( next?: string ): string {
			return next ?? ''
		}

		message_status() {
			return this.message() === this.message_saved() ? 'success' : 'error'
		}

		@ $mol_mem
		save_enabled() {
			return this.login().trim() !== '' && this.login().trim() !== ( this.profile()?.Login()?.val() ?? '' )
		}

		@ $mol_action
		save( next?: any ) {
			const profile = this.profile()
			if( !profile ) return

			const login = this.login().trim()
			if( !login ) {
				this.message( this.message_login_empty() )
				return
			}

			const current_key = this.profile_key()
			const profiles = this.profiles()

			if( current_key ) {
				if( current_key !== login && profiles.has( login ) ) {
					this.message( this.message_login_exists().replace( '{login}', login ) )
					return
				}

				if( current_key !== login ) {
					profiles.key( login, 'auto' )?.remote( profile )
					profiles.has( current_key, false )
				}
			}

			profile.Login( null )!.val( login )
			this.login( login )
			this.message( this.message_saved() )
		}

		@ $mol_action
		exit( next?: any ) {
			if( this.$.$shm_hitalama_settings.selfhosted_tauri_enabled() ) {
				this.$.$shm_hitalama_app.selfhosted_tauri_logout( true )
			}
			this.$.$shm_hitalama_profile.home().Hitalama_profile( null )?.remote( null )
			this.$.$mol_state_local.value( '$giper_baza_auth', null )
			this.$.$mol_state_local.value( '$' + 'hitalama_profile_gate.pending_login', null )
			this.$.$mol_state_arg.value( 'section', null )

			this.$.$mol_error_fence(
				()=> $mol_wire_sync( this.$.$mol_dom_context ).fetch( '/logout', { credentials: 'same-origin' } ),
				()=> null,
				promise => promise,
			)

			this.$.$mol_dom_context.location.href = '/login'
		}

	}

}
